import { combineReducers } from 'redux'

import { navigation } from '../../modules/Navigation'
import { map } from '../../modules/Map'

export default combineReducers({
  navigation,
  map,
})
